import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import GmailSideBarApp from './pages/content/gmail/SideBarApp';

const container = document.getElementById('root') as HTMLElement;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  enabled: true,
  tracesSampleRate: 1.0,
  environment: import.meta.env.VITE_ENV,
});

const root = createRoot(container);

root.render(
  <StrictMode>
    <BrowserRouter>
      <GmailSideBarApp />
    </BrowserRouter>
  </StrictMode>
);
